import React from 'react'
import styled from 'styled-components'

import CollectedData from '../../juniorPlusStations/Sensor/CollectedData'

import { rgba, APP_WHITE } from '../../constants/styles'

/**
 * Displays the collected data during a culminating moment.
 * @param props.culminatingMomentId The id of the culminating moment.
 */
export default function SensorData({
	culminatingMomentId,
}: {
	culminatingMomentId: string,
}): React$Node {
	return (
		<SensorSection>
			<Wrapper>
				<CollectedData collectedDataContext={{ type: 'CULMINATING_MOMENT', culminatingMomentId }} />
			</Wrapper>
		</SensorSection>
	)
}

const SensorSection = styled.div`
	width: 50%;
	margin-left: 20px;
	height: 100%;
	display: flex;
`

const Wrapper = styled.div`
	height: 100%;
	padding: 0px 0px 20px 0px;
	overflow-y: hidden;
	overflow-x: hidden;
	border-radius: 3px;
	color: ${APP_WHITE};
	display: flex;
	width: 100%;
	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-track {
		border-radius: 10px;
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: ${rgba(APP_WHITE, 0.2)};
	}
`
